import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, Card, CardActionArea, Typography } from "@material-ui/core";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import BarChartIcon from "@material-ui/icons/BarChart";
import EventNoteIcon from "@material-ui/icons/EventNote";
import PeopleIcon from "@material-ui/icons/People";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import PieChartIcon from "@material-ui/icons/PieChart";
import AssignmentIcon from "@material-ui/icons/Assignment";
import GavelIcon from "@material-ui/icons/Gavel";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import DescriptionIcon from "@material-ui/icons/Description";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { Wrapper } from "components/wrapper";
import { usePrestacaoContasTiposState } from "./context/prestacao-contas-tipos-context";
import { usePrestacaoContasTiposController } from "./context/prestacao-contas-tipos-controller";

const iconByTipoName = (name: string) => {
  const n = name.toUpperCase();
  if (n.includes("PPA") || n.includes("PLURIANUAL")) return EventNoteIcon;
  if (n.includes("LDO") || n.includes("DIRETRIZES")) return PeopleIcon;
  if (n.includes("LOA") || n.includes("ORÇAMENTÁRIA ANUAL")) return AccountBalanceWalletIcon;
  if (n.includes("ESTRATÉGICO")) return TrendingUpIcon;
  if (n.includes("JULGAMENTO")) return AccountBalanceIcon;
  if (n.includes("RGF") || n.includes("GESTÃO FISCAL")) return AssignmentIcon;
  if (n.includes("RREO") || n.includes("EXECUÇÃO ORÇAMENTÁRIA")) return BarChartIcon;
  if (n.includes("BALANÇO")) return PieChartIcon;
  if (n.includes("PARECER")) return GavelIcon;
  if (n.includes("AUDIÊNCIA")) return RecordVoiceOverIcon;
  if (n.includes("CONTROLE INTERNO")) return FindInPageIcon;
  if (n.includes("AUDITORIA")) return VerifiedUserIcon;
  return DescriptionIcon;
};

export function PrestacaoContasTiposPage() {
  const navigate = useNavigate();
  const { tipos, loading } = usePrestacaoContasTiposState();
  const { onInit } = usePrestacaoContasTiposController();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    (async () => {
      await onInit();
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Planejamento e Prestação de Contas" },
        ]}
      />
      <PageTitle>Planejamento e Prestação de Contas</PageTitle>
      <Wrapper>
        {loading ? (
          <Grid container justifyContent="center" style={{ padding: "48px 0" }}>
            <CircularProgress />
          </Grid>
        ) : (
          <Grid container spacing={3}>
            {tipos?.filter((tipo) => !tipo.name.toUpperCase().includes("AUDITORIA") && !tipo.name.toUpperCase().includes("ESTRATÉGICO")).map((tipo) => {
              const Icon = iconByTipoName(tipo.name);
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={tipo.id}>
                  <Card variant="outlined" style={{ height: "100%" }}>
                    <CardActionArea
                      style={{ height: "100%", padding: "24px 16px", display: "flex", flexDirection: "column", alignItems: "flex-start", gap: 12 }}
                      onClick={() => navigate(`/prestacao-contas/tipo/${tipo.id}`)}
                    >
                      <Icon color="primary" fontSize="large" />
                      <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                        {tipo.name}
                      </Typography>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
          </Grid>
        )}
      </Wrapper>
    </>
  );
}
